import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import ActivityService from "../../../../Services/Activity.service";
import ActivityFeed from "../../../Presentational/ActivityItem/ActivityFeed";
const AdvisorStudentsStaffPipelinesTab = ({ student, }) => {
    const itemSearch = React.useMemo(() => {
        return {
            global: {
                contextPeoplePersonIds: [student.personId],
                activityItemTypeIds: [ActivityItemTypeService.OpportunityId],
            },
            latestValue: [],
        };
    }, [student.personId]);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(student.personId), [student.personId]);
    return _jsx(ActivityFeed, { search: itemSearch, poll: poll });
};
export default AdvisorStudentsStaffPipelinesTab;
